export default __webpack_public_path__ + "static/media/icon_box-widgets-line.f640b776.svg";